import { render, staticRenderFns } from "./BaseProp.vue?vue&type=template&id=6ea3b782&scoped=true&"
import script from "./BaseProp.vue?vue&type=script&lang=js&"
export * from "./BaseProp.vue?vue&type=script&lang=js&"
import style0 from "./BaseProp.vue?vue&type=style&index=0&id=6ea3b782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea3b782",
  null
  
)

export default component.exports